var r={exports:{}};export{r as g};
//# sourceMappingURL=index6.js.map
